import { Stack, Typography } from '@mui/material';
import { useTranslation } from '../../common/LocalizationProvider';

export default function SubscriptionHead() {
  const t = useTranslation();

  return (
    <Stack
      direction={{ xs: 'column', sm: 'column', md: 'row' }}
      alignItems="center"
      justifyContent={{ xs: 'center', sm: 'center', md: 'space-between' }}
      sx={{ mb: 5 }}
    >
      <Typography variant="h4" gutterBottom>
        {t('sub')}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} spacing={1}>
        <Typography variant="h7" textAlign="center" gutterBottom>
          {t('sub_Cancel1')}
        </Typography>
        <Typography variant="h7" textAlign="center" gutterBottom>
          {t('sub_Cancel2')}
        </Typography>
      </Stack>
    </Stack>
  );
}
